/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:06:49
 * @Last Modified by: yanghailong
 * @Last Modified time: 2026-03-25 14:01:48
 */

import Konva from "konva"


/**
 * 属性相关操作
 * @mixin Property
 */
export class Property {
  constructor() {
    this.properties = new Map()
    this.prop_x = 50
    this.prop_y = 0
    this.prop_h = 16
    this.prop_is_show = true
  }
  /**
   * 添加一个属性
   * @param {string} key 属性key
   * @param {string} [unit] 属性值单位
   * @param {object} [rest={}] 其他属性
   */
  addProperty(key, unit = '', rest = {}) {
    let propLabel = new Konva.Text({
      x: this.prop_x,
      y: this.prop_y,
      text: `${key}: 0 ${unit}`,
      fill: '#000',
      ...rest
    })
    propLabel[key] = 0
    propLabel.unit = unit
    this.properties.set(key, propLabel)
    this.prop_y += this.prop_h
    if (this.g instanceof Konva.Group) {
      this.g.add(propLabel)
    }

    return propLabel
  }
  /**
   * 更新属性
   * @param {string} key 属性key
   * @param {*} value 属性值
   */
  updateProperty(key, value = '--') {
    if (this.properties.has(key)) {
      let propLabel = this.properties.get(key)
      propLabel.setAttr('text', `${key}: ${value} ${propLabel.unit}`)
      propLabel[key] = value
    }
  }
  /**
   * 获取属性的 Label 对象
   * @param {string} key
   * @returns {import('konva').default.Label}
   */
  getProperty(key) {
    if (this.properties.has(key)) {
      let propLabel = this.properties.get(key)
      return propLabel
    }
  }

  /**
   * 获取属性值
   * @param {string} key 属性key
   * @returns {string} 属性值
   */
  getValue(key) {
    if (this.properties.has(key)) {
      let propLabel = this.properties.get(key)
      return propLabel[key]
    }
    return null
  }
}
